import { ImageOff } from 'lucide-react';

/**
 * Neutral tile shown when an item or restaurant has no photo of its own.
 * Never substitute a stock photo: a picture of food that is not theirs misleads the customer.
 */
export default function NoImageTile({ name, className = '', dark = false }) {
  const tone = dark ? 'bg-[#252b33] text-white/40' : 'bg-muted text-muted-foreground';
  const initial = (name || '').trim().charAt(0).toUpperCase();
  return (
    <div
      className={`flex items-center justify-center ${tone} ${className}`}
      role="img"
      aria-label={name ? `${name} (no photo)` : 'No photo'}
      data-testid="no-image-tile"
    >
      {initial ? (
        <span className="text-2xl font-semibold opacity-60">{initial}</span>
      ) : (
        <ImageOff className="h-6 w-6 opacity-50" />
      )}
    </div>
  );
}
